/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
import React, { useState, useEffect, useRef } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";

import Drawer from "@material-ui/core/Drawer";
import cogoToast from "cogo-toast";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import PeopleIcon from "@material-ui/icons/People";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import icons from "../assets/icons/icon-collection.svg";
import Menu from "./Menu";
import BusinessMenu from "./Menu/BusinessMenu";
import ToolbarMenu from "./ToolbarMenu";
import ChatWidget from "../Pages/General/Home/ChatWidget/ChatWidget";
import { useTour } from "../components/TourProvider";
import { bool, node, object, func } from "prop-types";
import {
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
} from "@material-ui/core";
import axiosSetup from "../ajax";

import "./index.scss";
import LeaderBoard from "./LeaderBoard";
import ExpertBoard from "./ExpertBoard";
import ProfileCompletionWidget from "./ProfileRatingBoard";
import JobMatchScoreWidget from "./JobMatchScoreWidget";
import { useLocation, useHistory } from "react-router-dom";
import { uploadFile } from "../utils/helpers";
import {
  trackEvent,
  trackPostJobClick,
  trackJobUploadExcelClick,
  trackJobPostNewClick,
  trackJobPostPublishClick,
  trackJobPostVerificationClick,
} from "../utils/analytics";

import {
  createJobAction,
  createJobFromExcelAction,
  createJobRequest,
  clearJobCreated,
  postJobValidation,
} from "../redux/actions/jobActions";
import { CREATE_JOB } from "../redux/actionTypes";
import { validateJobForPublish } from "../utils/jobPublishValidation";
import { getStatus } from "../redux/actions/jobActions";

import CustomButton from "../components/CustomButton";
import Plus from "../assets/icons/Plus.svg";
import Upload from "../assets/icons/upload.svg";
import Hire from "../assets/icons/hire.svg";
import Referral from "../assets/icons/referral.svg";
import People from "../assets/icons/people.svg"; 
import Person from "../assets/icons/person.svg";
import AddNewPost from "./NewPost";
import BusinessAddNewPost from "../Pages/Business/BusinessNewPost";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../components/CustomInput";
import { demoAction } from "../redux/actions/demoActions";
import ReactTooltip from "react-tooltip";
import SlidingPane from "react-sliding-pane";
import JobDetails from "./NewPost/JobDetails/";
import AddDocuments from "./NewPost/JobDocuments/";
import { openRecruiterModal } from "../redux/actions/demoActions";
import JobTemplateSelector from "./NewPost/JobTemplateSelector";
import RequestHiringSupport from "./RequestHiringSupport";
import EmployerVerificationModal from "../components/EmployerVerificationModal";
import httpRequest from "../ajax";

const drawerWidth = 240;

const isBusinessUser = () => {
  const accountType = localStorage.getItem("accountType");
  return accountType === "business";
};

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    width: "100%",
    boxShadow: "2px 2px #eeeeee",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarClosed: {
    marginLeft: 73,
    width: `calc(100% - 73px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  black: {
    background: theme.palette.warning.main,
  },
  blue: {
    background: theme.palette.primary.main,
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  mobileDrawerHeader: {
    display: "flex",
    justifyContent: "flex-end",
    padding: theme.spacing(1.5, 1.5, 0, 1.5),
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  mobileDrawerCloseButton: {
    color: "#fff",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  paper: {
    background: "#ccc",
  },
}));

const createNewJobTemplate = () => ({
  campany_name: "",
  industry: "0",
  about_company: "",
  no_of_staff: "0",
  job_level: "0",
  role_title: "",
  job_type: "0",
  reports_to: "",
  applicant_benefit: "salary",
  skills_required: [],
  location: "",
  additional_files: [],
  isToRefTimeLineOrToHireRecruter: 1,
  isCompanyRepresentative: "1",
  salary: "",
  duration: "",
  canRecruiterRequest: "0",
  country: 0,
  job_tier: "0",
  estimated_views: "",
  worktype: "1",
  salary_range: "",
  currency: "",
  display_salary: 1,
});

const Layout = ({
  children,
  recruiter,
  isOnDuplicatePost,
  duplicatedDataValue,
  onDuplicateClose,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const uploadInputRef = useRef(0);
  const { chatWidgetRef } = useTour();

  const [open, setOpen] = useState(true);
  const [newPost, setNewPost] = useState(false);
  const [massUpload, setMassUpload] = useState(false);
  const [requestHiringSupportOpen, setRequestHiringSupportOpen] = useState(false);
  const [success, setSuccess] = useState("");
  const [status, setStatus] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [canPost, setCanPost] = useState(true);
  const [isFetching, setIsFetching] = useState(true);
  const { userData } = useSelector((store) => store.auth);
  const { id } = userData;

  const [industryOptions, setIndustryOptions] = useState({});
  const [workTypeOptions, setWorkTypeOptions] = useState({});
  const { profile } = useSelector((store) => store);
  const { profileData } = profile;
  const [levelOptions, setLevelOptions] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [skillOptions, setSkillOptions] = useState([]);
  const [isJobCreated, setIsJobCreated] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPublishingExcel, setIsPublishingExcel] = useState(false);
  const [isPublishingJob, setIsPublishingJob] = useState(false);
  const [isSavingDraft, setIsSavingDraft] = useState(false);
  const [displayMessage, setDisplayMessage] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showTemplateSelector, setShowTemplateSelector] = useState(false);

  const { pathname } = useLocation();
  const [width, setWidth] = useState(window.innerWidth);
  const history = useHistory();
  const [newJob, setNewJob] = useState(() => createNewJobTemplate());
  const [review, setReview] = useState({
    name: "",
    user_id: "",
    tax_id: "",
    website: "",
    role: [],
  });
  const [consentChecked, setConsentChecked] = useState(false);

  // Estimated salary modal state for Tier 3
  const [showEstimatedSalaryModal, setShowEstimatedSalaryModal] =
    useState(false);
  const [estimatedSalaryData, setEstimatedSalaryData] = useState(null);
  const [isEstimatingSalary, setIsEstimatingSalary] = useState(false);

  // Insufficient balance modal state for Tier 3
  const [showFundWalletModal, setShowFundWalletModal] = useState(false);
  const [fundWalletInfo, setFundWalletInfo] = useState(null);

  // Employer verification modal state (intent-first publish gate)
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [employerVerificationStatus, setEmployerVerificationStatus] = useState(null);
  const [employerVerificationEmailNotice, setEmployerVerificationEmailNotice] =
    useState({ open: false, companyEmail: "" });

  const { industry, skill, job } = useSelector((store) => store);
  const { allSkills } = skill;
  const [isChecked, setIsChecked] = useState(false);
  const { industries } = industry;
  const [loading, setLoading] = useState(false);
  const { jobLevels } = job;
  const accountType = localStorage.getItem("accountType");
  const userDataString = sessionStorage.getItem("userData");
  const auth = useSelector((store) => store.auth);
  const {
    userData: { account_type, company },
  } = useSelector((store) => store.auth);

  const company_id = company ? company.id : "";

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };
  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };
  const handleForm = (e) => {
    const { name, value, checked, type } = e.target;
    if (type === "checkbox") {
      if (checked) {
        setReview({ ...review, role: [...review.role, value] });
      } else {
        setReview({
          ...review,
          role: review.role.filter((role) => role !== value),
        });
      }
    } else {
      setReview({ ...review, [name]: value });
    }
  };
  const handleSubmiting = async (e) => {
    // CRITICAL: Prevent default form submission FIRST
    e.preventDefault();
    
    setIsSubmitting(true);
    
    try {
      // Get user data from localStorage (not sessionStorage) or Redux
      let userDataString = localStorage.getItem("userData");
      let profileId = null;
      
      if (!userDataString && auth?.userData) {
        // Fallback to Redux state if localStorage is empty
        profileId = auth.userData.id;
      } else if (userDataString) {
        const userData = JSON.parse(userDataString);
        profileId = Number(userData.id);
      }

      if (!profileId) {
        throw new Error("User session not found. Please log in again.");
      }

      const data = {
        name: review.name,
        user_id: profileId,
        tax_id: review.tax_id,
        website: review.website,
        role: JSON.stringify(review.role),
      };
      
      console.log("Submitting job poster validation:", data);
      const response = await postJobValidation(dispatch, data);
      console.log("Response:", response);

      // Show success message
      cogoToast.success("Your request has been submitted successfully! We will review it and get back to you soon.", {
        hideAfter: 5,
        position: "top-center",
      });

      // Clear form
      setReview({
        name: "",
        user_id: "",
        tax_id: "",
        website: "",
        role: [],
      });
      setIsChecked(false);

      // Close the modal
      setShowConfirmation(false);
      setDisplayMessage(true);
    } catch (error) {
      console.error("Error submitting job poster validation:", error);
      const errorMessage = error?.response?.data?.error || error?.message || "Failed to submit request. Please try again.";
      // cogoToast.error(errorMessage, {
      //   hideAfter: 5,
      //   position: "top-center",
      // });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (isOnDuplicatePost && duplicatedDataValue) {
      setNewPost(true);
      setNewJob((prev) => ({
        ...prev,
        ...duplicatedDataValue,
        skills_required:
          duplicatedDataValue.skills_required ||
          duplicatedDataValue.skills ||
          prev.skills_required,
      }));
    }
  }, [isOnDuplicatePost, duplicatedDataValue]);
  useEffect(() => {
    if (width <= 1024) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [width]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    
    // Custom event to open new post template selector from any child component
    const handleOpenTemplateSelector = () => {
      handleNewPost();
    };
    window.addEventListener("open-template-selector", handleOpenTemplateSelector);
    
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
      window.removeEventListener("open-template-selector", handleOpenTemplateSelector);
    };
  }, []);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const {
    userData: { user_type },
  } = useSelector((store) => store.auth);

  useEffect(() => {
    if (user_type === "1") {
      setCanPost(true);
    } else {
      setCanPost(false);
    }
  }, [dispatch]);

  const handleNewPost = () => {
    const userJobCount = job?.myJobs?.length || 0;
    trackPostJobClick({
      is_first_time: userJobCount === 0,
      user_job_count_before_click: userJobCount,
    });
    clearJobCreated(dispatch);
    setShowTemplateSelector(true);
  };

  useEffect(() => {
    if (sessionStorage.getItem("intent") === "post-job") {
      sessionStorage.removeItem("intent");
      handleNewPost();
    }
  }, []);

  const handleTemplateSelected = (jobData) => {
    setShowTemplateSelector(false);
    const templatePayload = {
      campany_name: jobData.campany_name || jobData.company_name || "",
      industry: jobData.industry || "0",
      about_company: jobData.about_company || "",
      no_of_staff: jobData.no_of_staff || "0",
      job_level: jobData.job_level || "0",
      role_title: jobData.role_title || "",
      job_type: jobData.job_type || "0",
      reports_to: jobData.reports_to || "",
      applicant_benefit: jobData.applicant_benefit || "salary",
      skills_required: Array.isArray(jobData.skills_required)
        ? jobData.skills_required
        : Array.isArray(jobData.skills)
        ? jobData.skills
        : [],
      location: jobData.location || "",
      additional_files: Array.isArray(jobData.additional_files)
        ? jobData.additional_files
        : [],
      isToRefTimeLineOrToHireRecruter:
        jobData.isToRefTimeLineOrToHireRecruter || 1,
      isCompanyRepresentative: jobData.isCompanyRepresentative || "1",
      salary: jobData.salary || "",
      duration: jobData.duration || "",
      canRecruiterRequest: jobData.canRecruiterRequest || "0",
      country: jobData.country || 0,
      job_tier: jobData.job_tier || "0",
      estimated_views: jobData.estimated_views || "",
      worktype: jobData.worktype || jobData.work_type || "1",
      salary_range: jobData.salary_range || "",
      currency: jobData.currency || jobData.salary_currency || "",
      is_draft: "0",
    };
    setNewJob(templatePayload);
    setNewPost(true);
  };

  const handleCreateNewFromSelector = () => {
    const userJobCount = job?.myJobs?.length || 0;
    trackJobPostNewClick({
      is_first_time: userJobCount === 0,
    });
    setShowTemplateSelector(false);
    setNewJob(createNewJobTemplate());
    setNewPost(true);
  };
  const handleShowConfirmation = () => {
    setShowConfirmation(true);
  };

  const notifyDuplicateClosed = () => {
    if (typeof onDuplicateClose === "function") {
      onDuplicateClose();
    }
  };

  const handleClose = () => {
    setSuccess(false);
    setNewPost(false);
    setNewJob(createNewJobTemplate());
    setHasUnsavedChanges(false);
    notifyDuplicateClosed();
  };

  const handleCloseAttempt = () => {
    if (hasUnsavedChanges) {
      setShowWarningModal(true);
    } else {
      setNewPost(false);
      setShowTemplateSelector(true);
      setHasUnsavedChanges(false);
    }
  };

  // Navigation blocking - show modal when trying to navigate away with data
  useEffect(() => {
    let unblock;
    if (newPost) {
      unblock = history.block((location, action) => {
        // Don't block navigation if we're currently saving a draft or publishing a job
        if (isSavingDraft || isPublishingJob) {
          return true; // Allow navigation
        }

        const hasData =
          newJob.role_title ||
          newJob.about_company ||
          newJob.industry !== "0" ||
          newJob.job_level !== "0" ||
          newJob.location ||
          newJob.skills_required.length > 0 ||
          newJob.additional_files.length > 0 ||
          newJob.job_type !== "0" ||
          newJob.reports_to ||
          newJob.no_of_staff !== "0";

        if (hasData && hasUnsavedChanges) {
          setShowWarningModal(true);
          return false; // Block navigation
        }
        return true; // Allow navigation
      });
    }

    return () => {
      if (unblock) unblock();
    };
  }, [newPost, newJob, hasUnsavedChanges, isSavingDraft, isPublishingJob, history]);

  const confirmClose = () => {
    setShowWarningModal(false);
    setHasUnsavedChanges(false);
    setNewPost(false);
    setShowTemplateSelector(true);
  };

  const cancelClose = () => {
    setShowWarningModal(false);
  };

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  const handleCloseMobile = () => {
    setOpen(false);
  };

  const displayMenu = () => {
    const isMobile = width <= 1024;
    return isBusinessUser() ? (
      <BusinessMenu
        open={open}
        toolbar={classes.toolbar}
        handleCloseMobile={handleCloseMobile}
        isMobile={isMobile}
      />
    ) : (
      <Menu
        open={open}
        toolbar={classes.toolbar}
        handleCloseMobile={handleCloseMobile}
        isMobile={isMobile}
      />
    );
  };

  useEffect(() => {
    const options = {};
    industries &&
      industries.forEach(
        (industry) => (options[industry.title] = industry.title)
      );
    setIndustryOptions(options);
  }, [industries]);

  useEffect(() => {
    const options = {};
    allSkills.forEach((skill) => (options[skill.title] = skill.title));
    setSkillOptions(allSkills);
  }, [allSkills]);

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent("post-job-modal-state", {
        detail: { isOpen: newPost || showTemplateSelector },
      })
    );
  }, [newPost, showTemplateSelector]);

  useEffect(() => {
    const options = {};
    jobLevels &&
      jobLevels.forEach((level) => (options[level.id] = level.title));
    setLevelOptions(options);
  }, [jobLevels]);

  const handleChange = ({ target: { value, name } }) => {
    // Use functional update to avoid stale-state when multiple rapid updates occur
    setNewJob((prev) => {
      const nextJob = { ...prev, [name]: value };
      if (name === "job_tier" && parseInt(value, 10) === 3) {
        nextJob.display_salary = 1;
      }
      return nextJob;
    });
    setHasUnsavedChanges(true);
  };

  const setSelectedSkills = (skills) => {
    setNewJob((prev) => ({ ...prev, skills_required: skills }));
    setHasUnsavedChanges(true);
  };

  const sendToRecruiter = async (e) => {
    e.preventDefault();
    openRecruiterModal(dispatch);

    /*
    e.preventDefault();
    if (
      !newJob.campany_name ||
      !newJob.industry ||
      !newJob.about_company ||
      !newJob.no_of_staff ||
      !newJob.job_level ||
      !newJob.role_title ||
      !newJob.job_type ||
      !newJob.reports_to ||
      !newJob.applicant_benefit ||
      !newJob.skills_required ||
      !newJob.location ||
      !newJob.salary ||
      !newJob.duration
    ) {
      return cogoToast.error("Please fill all fields");
    }
    const job_level = parseInt(newJob.job_level, 10);
    const isCompanyRepresentative = parseInt(
      newJob.isCompanyRepresentative,
      10
    );
    const canRecruiterRequest = parseInt(newJob.canRecruiterRequest, 10);
    const jobToSend = {
      ...newJob,
      ...{ job_level, isCompanyRepresentative, canRecruiterRequest },
    };

    history.push({
      pathname: "/recruiter/hire",
      state: { jobToSend },
    });
    closeDialog();


    */
  };
  const updateSelectedCountryID = (cid) => {
    setNewJob({ ...newJob, ...{ country: cid } });
  };

  const addDocLink = (link) => {
    const links = [...newJob.additional_files];
    links.push(link);
    setNewJob({ ...newJob, ...{ additional_files: links } });
    setHasUnsavedChanges(true);
  };
  const [linksObject, setLinksObject] = useState([]);
  const addDocLinkObject = (link) => {
    const links = [...linksObject];
    links.push(link);
    setLinksObject(links);
  };
  const [value, setValue] = useState(0);

  const handleChangeUpload = ({ target: { files } }) => {
    if (files && files[0]) {
      setIsUploading(true);

      Promise.resolve(
        uploadFile(
          files[0],
          "https://api.cloudinary.com/v1_1/workbrook-hash/raw/upload"
        )
      )
        .then(({ data, success }) => {
          if (success) {
            addDocLink(data);
            addDocLinkObject({ link: data, name: files[0].name });
          } else {
            cogoToast.error("Unsuccessful document upload", {
              hideAfter: 4,
              position: "top-center",
            });
          }
        })
        .finally(() => {
          setIsUploading(false);
        });
    }
  };
  const handleRefClick = () => {
    uploadInputRef.current.click();
  };

  // Estimate salary for Tier 3 jobs
  const estimateSalaryForTier3 = async () => {
    const roleTitle = newJob.role_title;
    const location = newJob.location;
    const industry = newJob.industry;
    const country = newJob.country;
    const salaryRange = newJob.salary_range;
    const duration = newJob.duration;
    const currency = newJob.currency;

    if (!roleTitle || !location || !industry || industry === "0") {
      cogoToast.error(
        "Please fill in Role Title, Location, and Industry to estimate salary"
      );
      return null;
    }

    try {
      const params = new URLSearchParams({
        type: "1",
        role_title: roleTitle,
        location,
        industry: industry || "",
        country: String(country || ""),
      });
      if (salaryRange) params.append("salary_range", salaryRange);
      if (duration) params.append("duration", duration);
      if (currency) params.append("currency", currency);

      const response = await axiosSetup(
        "get",
        `/jobs/estimate-salary?${params.toString()}`
      );

      const data = response.data?.data || response.data;

      if (
        data &&
        data.estimated_annual_salary !== undefined &&
        data.estimated_annual_salary !== null
      ) {
        const estimatedSalary = data.estimated_annual_salary;
        const currency = data.currency || data.currency_code || "USD";

        return {
          estimated_salary: estimatedSalary,
          currency: String(currency).toUpperCase(),
          formatted_salary: estimatedSalary.toLocaleString("en-US"),
          source: data.source || null,
        };
      } else {
        cogoToast.error(
          "Salary estimation service is currently unavailable. Please try again later."
        );
        return null;
      }
    } catch (error) {
      const status = error?.response?.status;
      const msg =
        status === 500
          ? "Salary estimation service is currently unavailable. Please try again later."
          : "Error estimating salary. Please try again.";
      cogoToast.error(msg);
      return null;
    }
  };

  // Submit job after user accepts estimated salary modal
  const submitJobWithEstimatedSalary = () => {
    setShowEstimatedSalaryModal(false);
    setHasUnsavedChanges(false);
    setIsPublishingJob(true);

    const job_level = parseInt(newJob.job_level, 10);
    const isCompanyRepresentative = parseInt(
      newJob.isCompanyRepresentative,
      10
    );
    const job_tier = parseInt(newJob.job_tier, 10);

    const { estimated_views: _, ...jobDataWithoutEstimatedViews } = newJob;

    // Remove salary field to avoid conflicts, use estimated_salary instead
    delete jobDataWithoutEstimatedViews.salary;

    // Prepare the base payload - include currency from estimated salary so backend uses correct currency for payment
    const payload = {
      ...jobDataWithoutEstimatedViews,
      job_level,
      isCompanyRepresentative,
      canRecruiterRequest: parseInt(newJob.canRecruiterRequest),
      job_tier,
      display_salary: 1,
      estimated_salary: estimatedSalaryData.estimated_salary,
      currency: estimatedSalaryData.currency || newJob.currency || "NGN",
    };

    createJobAction(dispatch, payload)
      .then(() => {
        setIsJobCreated(true);
        setIsPublishingJob(false);
        setEstimatedSalaryData(null);
        history.push("/home");
      })
      .catch((error) => {
        setIsPublishingJob(false);
        const msg = error?.data?.message || "";
        if (msg.toLowerCase().includes("insufficient wallet balance") || msg.toLowerCase().includes("wallet not found")) {
          setFundWalletInfo({
            message: msg,
            required_amount: error?.data?.required_amount,
            required_currency: error?.data?.required_currency,
            available_balance: error?.data?.available_balance,
          });
          setShowFundWalletModal(true);
        }
      })
      .finally(() => {
        setIsPublishingJob(false);
      });
  };

  const buildJobPayloadFromNewJob = (jobState, { isDraft = false, publishStatus } = {}) => {
    const job_tier = parseInt(jobState.job_tier, 10);
    const { estimated_views: _ev, ...jobDataWithoutEstimatedViews } = jobState;
    const data = { ...jobDataWithoutEstimatedViews };
    if (data.salary) {
      delete data.salary;
    }

    const payload = {
      ...data,
      job_level: parseInt(jobState.job_level, 10),
      isCompanyRepresentative: parseInt(jobState.isCompanyRepresentative, 10),
      canRecruiterRequest: parseInt(jobState.canRecruiterRequest, 10),
      job_tier,
      is_draft: isDraft ? "1" : "0",
      display_salary: job_tier === 3 ? 1 : jobState.display_salary,
    };

    if (job_tier === 2 && !isDraft && jobState.estimated_views) {
      const estimatedViews = parseInt(jobState.estimated_views, 10);
      if (!Number.isNaN(estimatedViews) && estimatedViews >= 1) {
        payload.estimated_views = estimatedViews;
      }
    }

    if (publishStatus) {
      payload.publish_status = publishStatus;
    }

    return payload;
  };

  const handleEmployerVerificationSubmit = async (verificationForm) => {
    const userJobCount = job?.myJobs?.length || 0;
    trackJobPostVerificationClick({
      company_name: verificationForm?.company_name,
      company_email: verificationForm?.company_email,
      is_first_time: userJobCount === 0,
    });
    const validation = validateJobForPublish(newJob);
    if (!validation.valid) {
      cogoToast.error(validation.message, { position: "top-center" });
      return false;
    }

    setIsPublishingJob(true);

    try {
      try {
        const verResponse = await httpRequest(
          "post",
          "/employer-verification/submit",
          verificationForm,
        );

        if (!verResponse.data?.status) {
          cogoToast.error(
            verResponse.data?.message || "Verification submission failed.",
            { position: "top-center" },
          );
          return false;
        }
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          "Failed to submit verification. Please try again.";
        cogoToast.error(msg, { position: "top-center" });
        return false;
      }

      const pendingPayload = buildJobPayloadFromNewJob(newJob, {
        isDraft: false,
        publishStatus: "pending_verification",
      });

      try {
        const jobResponse = await createJobRequest(pendingPayload);
        if (jobResponse?.data?.data) {
          dispatch({ type: CREATE_JOB, payload: jobResponse.data.data });
        }
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          "Verification saved, but the job failed to publish. Please try again from My Jobs or contact support.";
        cogoToast.error(msg, { position: "top-center" });
        return false;
      }

      setEmployerVerificationStatus("pending");
      setIsJobCreated(true);
      setHasUnsavedChanges(false);
      setEmployerVerificationEmailNotice({
        open: true,
        companyEmail: String(verificationForm.company_email || "").trim(),
      });
      cogoToast.success(
        "Verification submitted. Check your company email to finish verifying.",
        { hideAfter: 5, position: "top-center" },
      );
      history.push("/myjobs");
      return true;
    } finally {
      setIsPublishingJob(false);
    }
  };

  const handleSubmit = async (e, isDraftParam = null) => {
    e.preventDefault();

    const job_tier = parseInt(newJob.job_tier, 10);
    const isDraft =
      isDraftParam !== null ? isDraftParam : newJob.is_draft === "1";

    if (job_tier === 3 && !isDraft) {
      if (!newJob.salary_range || !newJob.currency || newJob.currency === "0" || !newJob.duration || newJob.duration === "0") {
        cogoToast.error("Please provide salary range, currency, and duration for Tier 3 jobs");
        return;
      }
    }

    // For Tier 3, estimate salary first and show modal (only for published jobs)
    if (job_tier === 3 && !isDraft) {
      setIsEstimatingSalary(true);
      const salaryData = await estimateSalaryForTier3();
      setIsEstimatingSalary(false);

      if (salaryData) {
        setEstimatedSalaryData(salaryData);
        setShowEstimatedSalaryModal(true);
      }
      return;
    }

    // Employer verification gate: referral users only (partners with provider skip)
    const isPartner = !!(userData?.provider);
    if (!isDraft && accountType === "referral" && !isPartner) {
      try {
        const verRes = await httpRequest("get", `/employer-verification/status?company_name=${encodeURIComponent(newJob.campany_name || "")}`);
        const verData = verRes?.data?.data || {};
        const verStatus = verData.verification_status;
        const companyEmailVerified = Boolean(verData.company_email_verified);
        setEmployerVerificationStatus(verStatus);

        const canPublishAsVerified =
          verStatus === "approved" ||
          (verStatus === "pending" && companyEmailVerified);

        if (canPublishAsVerified) {
          // Verified (or company email confirmed) — proceed to publish live
        } else if (verStatus === "pending") {
          const validation = validateJobForPublish(newJob);
          if (!validation.valid) {
            cogoToast.error(validation.message, { position: "top-center" });
            return;
          }
          cogoToast.info(
            "Please verify your company email to publish this job. We've saved it as a draft for now.",
            { hideAfter: 6, position: "top-center" },
          );
          setIsSavingDraft(true);
          const draftPayload = buildJobPayloadFromNewJob(newJob, {
            isDraft: true,
            publishStatus: "pending_verification",
          });
          createJobAction(dispatch, draftPayload)
            .then(() => {
              setIsJobCreated(true);
              setHasUnsavedChanges(false);
              history.push("/myjobs");
            })
            .finally(() => setIsSavingDraft(false));
          return;
        } else {
          const validation = validateJobForPublish(newJob);
          if (!validation.valid) {
            cogoToast.error(validation.message, { position: "top-center" });
            return;
          }
          // not_found or denied — show verification modal
          setShowVerificationModal(true);
          return;
        }
      } catch (verErr) {
        console.error("Employer verification check failed:", verErr);
        cogoToast.error(
          "Could not verify your employer status. Check your connection and try again.",
          { position: "top-center" },
        );
        return;
      }
    }

    // Set appropriate loading state based on whether it's a draft or not
    if (isDraft) {
      setIsSavingDraft(true);
    } else {
      setIsPublishingJob(true);
    }

    if (job_tier === 2 && !isDraft && newJob.estimated_views) {
      const estimatedViews = parseInt(newJob.estimated_views, 10);
      if (Number.isNaN(estimatedViews) || estimatedViews < 1) {
        cogoToast.error("Please enter a valid Estimated Views (at least 1)");
        setIsSavingDraft(false);
        setIsPublishingJob(false);
        return;
      }
    }

    const payload = buildJobPayloadFromNewJob(newJob, {
      isDraft,
      publishStatus: isDraft ? "pending_verification" : "live",
    });

    createJobAction(dispatch, payload)
      .then((action) => {
        setIsJobCreated(true);
        setHasUnsavedChanges(false);
        setIsSavingDraft(false);
        setIsPublishingJob(false);
        
        if (action?.payload?.publish_status === "pending_verification") {
          setShowVerificationModal(true);
        } else {
          history.push("/home");
        }
      })
      .catch((error) => {
        console.log(error);
        setIsSavingDraft(false);
        setIsPublishingJob(false);
      })
      .finally(() => {
        setIsSavingDraft(false);
        setIsPublishingJob(false);
      });
  };

  // Legacy questionnaire status check removed — replaced by intent-first publish gate
  // useEffect(() => { handleStatus(); }, []);

  //   useEffect(() => {
  //    const fetchVerificationStatus = useCallback(async () => {
  //   try {
  //     const userDataString = await sessionStorage.getItem("userData");

  //     if (!userDataString) {
  //       console.error("No user data found in session storage");
  //       setIsFetching(false);
  //       return false;
  //     }

  //     const userData = JSON.parse(userDataString);
  //     const profileId = Number(userData?.id);

  //     console.log("profileId", profileId);

  //     if (profileId) {
  //       const action = await getVerification(dispatch, profileId);
  //       const successes = action.payload.success;
  //       setSuccess(successes);

  //       // console.log("Verification success", successes);
  //     } else {
  //       console.error("Profile ID not found in parsed user data");
  //       return false;
  //     }
  //   } catch (error) {
  //     console.error("Error fetching verification status:", error);
  //     return false;
  //   } finally {
  //     setIsFetching(false);
  //   }
  //    }, [dispatch]);
  //     fetchVerificationStatus()
  //  }, [dispatch])

  const handleStatus = async () => {
    try {
      const profileId = Number(id);

      if (profileId) {
        const action = await getStatus(dispatch, profileId);
        const status = action.payload.status;
        const successes = action.payload.success;

        setStatus(status);
        setSuccess(successes);
      }
      console.log(success);
    } catch (error) {
      console.log(error);
      return false;
    } finally {
      setIsFetching(false);
    }
  };

  const handleExcelFileUpload = (e) => {
    e.preventDefault();
    setIsPublishingExcel(true);
    console.log(`linksObject === ${JSON.stringify(linksObject)}`);
    // [{"link":"https://res.cloudinary.com/workbrook-hash/raw/upload/v1691354941/Uploads/ua0v2oycek2ucvj44ivm.xlsx","name":"workbrook mass job template.xlsx"}]
    let data = {
      fileLink: linksObject[0].link,
    };
    console.log(`data === ${JSON.stringify(data)}`);

    const response = createJobFromExcelAction(dispatch, data)
      .then(() => {
        if (response) {
          setIsJobCreated(true);
        }
      })
      .catch((error) => {
        console.log(error);
        cogoToast.error("Error uploading jobs");
      })
      .finally(() => {
        setIsPublishingExcel(false);
      });
  };

  return (
    <div className="wrapper d-flex">
      <ReactTooltip />

      <AppBar
        color="secondary"
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open && width > 1024,
          [classes.appBarClosed]: !open && width > 1024,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton)}
          >
            <svg width="18" height="16">
              <use href={`${icons}#menubutton`}></use>
            </svg>
          </IconButton>
          <ToolbarMenu 
            onPostJob={handleNewPost}
            onRequestHiringSupport={() => setRequestHiringSupportOpen(true)}
            onUploadJobs={() => setMassUpload(true)}
          />
        </Toolbar>
      </AppBar>
      <Drawer
        variant={width <= 1024 ? "temporary" : "permanent"}
        open={open}
        onClose={() => setOpen(false)}
        className={clsx(classes.drawer, {
          [classes.blue]: !recruiter,
          [classes.black]: recruiter,
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.blue]: !recruiter,
            [classes.black]: recruiter,
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        {width <= 768 && open && (
          <div className={classes.mobileDrawerHeader}>
            <IconButton
              aria-label="Close navigation"
              onClick={() => setOpen(false)}
              className={classes.mobileDrawerCloseButton}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </div>
        )}
        {displayMenu()}
      </Drawer>
      <main className={classes.content}>
        <div className="mt-5 d-flex">
          <div className="main-content mr-md-4">{children}</div>

          <div
            className={`${pathname.includes("jobs-posted") || pathname === "/league" ? "d-none" : "d-none d-md-block w-25 shrink-0"} ${
              pathname.includes("league") ? "sidebar-independent-scroll" : ""
            }`}
          >
            {canPost && accountType === "referral" && !pathname.includes("/my-job-posts") && (
              <>
                <CustomButton
                  icon={Plus}
                  backgroundColor="#3A6ED4"
                  color="#fff"
                  alt="add post"
                  text="Post a job"
                  additionalClass="my-3 joyride-post-job"
                  handleClick={(e) => {
                    e.preventDefault();
                    handleNewPost();
                  }}
                />
                <CustomButton
                  icon={Upload}
                  backgroundColor="#3A6ED4"
                  color="#fff"
                  alt="add post"
                  text={"Upload Jobs from excel"}
                  additionalClass="joyride-post-job"
                  handleClick={(e) => {
                    const userJobCount = job?.myJobs?.length || 0;
                    trackJobUploadExcelClick({
                      is_first_time: userJobCount === 0,
                      template_downloaded: false,
                    });
                    setMassUpload(true);
                  }}
                />
                <CustomButton
                  icon={People}
                  backgroundColor="#3A6ED4"
                  color="#fff"
                  alt="request hiring support"
                  text={"Request Hiring Support"}
                  additionalClass="my-3 joyride-post-job"
                  handleClick={(e) => {
                    e.preventDefault();
                    setRequestHiringSupportOpen(true);
                  }}
                />
              </>
            )}

            {canPost && accountType === "business" && !pathname.includes("/my-job-posts") && (
              <>
                <CustomButton
                  icon={Plus}
                  backgroundColor="#3A6ED4"
                  color="#fff"
                  alt="add post"
                  text={" Post a Job"}
                  additionalClass="my-3 joyride-post-job"
                  handleClick={(e) => {
                    e.preventDefault();
                    const state = {
                      ["Post a Job"]: false,
                      ["Click on Post a Job"]: false,
                      ["Post to referral timeline"]: true,
                      ["Don't forget to add your files and links"]: true,
                    };
                    demoAction(dispatch, state);
                    handleNewPost();
                  }}
                />

                <CustomButton
                  icon={Upload}
                  backgroundColor="#3A6ED4"
                  color="#fff"
                  alt="add post"
                  text={"Upload Jobs from excel "}
                  additionalClass="my-3 joyride-post-job"
                  handleClick={(e) => {
                    const userJobCount = job?.myJobs?.length || 0;
                    trackJobUploadExcelClick({
                      is_first_time: userJobCount === 0,
                      template_downloaded: false,
                    });
                    setMassUpload(true);
                  }}
                />
              </>
            )}
            {!canPost && <div style={{ height: "60px" }}></div>}
            {isBusinessUser() ? (
              <BusinessAddNewPost
                open={newPost}
                handleClose={handleClose}
                setHasUnsavedChanges={setHasUnsavedChanges}
                setSuccess={setSuccess}
                success={success}
              />
            ) : (
              <AddNewPost
                open={false}
                handleClose={handleClose}
                setSuccess={setSuccess}
                success={success}
              />
            )}
            {pathname.includes("league/list") ||
            pathname.includes("league/points") ||
            pathname === "/league" ? (
              <></>
            ) : (
              <div className="mt-3">
                {userData.profileCompletionLevelPercent < 100 && (
                  <ProfileCompletionWidget />
                )}
                <br />
                {!pathname.includes("job-match-score") && (
                  <>
                    <JobMatchScoreWidget />
                    <br />
                  </>
                )}
                <LeaderBoard />
                <br />
                <ExpertBoard />
                {/*   
      !isBusinessUser ?    */}
                <div>
                  <SlidingPane
                    className=""
                    overlayClassName="some-custom-overlay-class"
                    isOpen={massUpload}
                    title="Mass Upload"
                    subtitle="Upload Jobs from excel"
                    width={width <= 1024 ? "100%" : "90%"}
                    height="10%"
                    from={"right"}
                    onRequestClose={() => {
                      // triggered on "<" on left top click or on outside click
                      setMassUpload(false);
                      // setOpen(false);
                    }}
                  >
                    <div
                      className="col-12 col-md-6"
                      style={{
                        marginTop: "4rem",
                        padding: "0px",
                        maxWidth: "640px",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <input
                        ref={uploadInputRef}
                        type="file"
                        onChange={handleChangeUpload}
                        style={{ display: "none" }}
                        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      />

                      <CustomButton
                        backgroundColor="#FFF"
                        color="#3A6ED4"
                        text="Upload an Excel file"
                        handleClick={handleRefClick}
                        loading={isUploading}
                        style={{ height: 200 }}
                      />

                      <div className="mt-3">
                        <CustomButton
                          backgroundColor="#FFFFFF"
                          color="#3A6ED4"
                          text={"Download excel sample format"}
                          handleClick={(e) => {
                            e.preventDefault();
                            const userJobCount = job?.myJobs?.length || 0;
                            trackJobUploadExcelClick({
                              is_first_time: userJobCount === 0,
                              template_downloaded: true,
                            });
                            window.open(
                              "https://res.cloudinary.com/workbrook-hash/raw/upload/v1762249483/Uploads/mvur75oudcev0npvullm.xlsx",
                              "_blank"
                            );
                          }}
                        />
                      </div>

                      <div className="pb-5">
                        <div className="d-flex flex-column">
                          <br />
                          <br />
                          {linksObject.map((fileLink, index) => (
                            <a
                              className="doc-linkx text-underline bg-primaryx mid-radius py-3 my-1 w-100 text-left p-2"
                              key={index.toString()}
                              href={fileLink.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <b>
                                Filename:{" "}
                                {fileLink.name ? fileLink.name : fileLink.link}
                              </b>
                            </a>
                          ))}
                        </div>
                      </div>

                      <div
                        className="col-12 col-md-12"
                        style={{ padding: "0px", marginBottom: "50px" }}
                      >
                        <CustomButton
                          type="submit"
                          // disabled= {linksObject.length <0 && true}

                          backgroundColor="#41B883"
                          handleClick={(e) => {
                            e.preventDefault();
                            const userJobCount = job?.myJobs?.length || 0;
                            trackJobPostPublishClick({
                              is_first_time: userJobCount === 0,
                              source: "excel_upload",
                            });
                            const state = {
                              ["Post a Job"]: false,
                              ["Click on Post a Job"]: false,
                              ["Don't forget to add your files and links"]: false,
                              ["Post to referral timeline"]: true,
                              ["Fill In Details"]: false,
                            };
                            demoAction(dispatch, state);
                            handleExcelFileUpload(e);
                          }}
                          color="#fff"
                          text={
                            isPublishingExcel
                              ? "Publishing..."
                              : "Publish Job to Referral"
                          }
                          additionalClass=""
                          disabled={isPublishingExcel}
                        />
                      </div>
                    </div>
                  </SlidingPane>
                  {accountType === "referral" && (
                    <React.Fragment>
                      <SlidingPane
                        className=""
                        overlayClassName="some-custom-overlay-class"
                        isOpen={newPost}
                        title="New Post"
                        subtitle="Create a New Job Post"
                        width={width <= 1024 ? "100%" : "90%"}
                        height="100%"
                        from={"right"}
                        onRequestClose={handleCloseAttempt}
                      >
                        <JobDetails
                          setSelectedSkills={setSelectedSkills}
                          handleChange={handleChange}
                          updateSelectedCountryID={updateSelectedCountryID}
                          industryOptions={industryOptions}
                          workTypeOptions={workTypeOptions}
                          levelOptions={levelOptions}
                          skillOptions={skillOptions}
                          setNewJob={setNewJob}
                          newJob={newJob}
                          duplicateData={
                            isOnDuplicatePost
                              ? { ...(duplicatedDataValue || {}), ...newJob }
                              : {}
                          }
                          isOnDuplicatePost={isOnDuplicatePost}
                        />

                        <AddDocuments
                          job={newJob}
                          addDocLinkObject={(link) => addDocLinkObject(link)}
                          addDocLink={(link) => addDocLink(link)}
                          linksObject={linksObject}
                        />

                        {(newJob.job_tier == 2 || newJob.job_tier == 3) && (
                          <div
                            className="col-12 pl-0 ml-0"
                            style={{ margin: "8px 0" }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={consentChecked}
                                  onChange={(e) =>
                                    setConsentChecked(e.target.checked)
                                  }
                                  name="financialConsent"
                                  color="primary"
                                  required
                                  style={{
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                    alignSelf: "flex-start",
                                  }}
                                />
                              }
                              label={
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                  }}
                                >
                                  I consent that I have read the{" "}
                                  <a
                                    href="https://workbrook.com/apps-term-of-use/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#4DABF7",
                                      textDecoration: "underline",
                                      fontWeight: "500",
                                      marginLeft: "4px",
                                      marginRight: "4px",
                                    }}
                                  >
                                    term of use
                                  </a>
                                  and understand the financial implication of
                                  this post
                                </span>
                              }
                              style={{
                                marginLeft: 0,
                                display: "flex",
                                alignItems: "flex-start",
                              }}
                              labelPlacement="end"
                            />
                          </div>
                        )}

                        <div
                          className="col-12 p-3"
                          style={{ display: "flex", gap: "12px" }}
                        >
                          <CustomButton
                            type="submit"
                            backgroundColor="#6c757d"
                            handleClick={(e) => {
                              e.preventDefault();
                              const state = {
                                ["Post a Job"]: false,
                                ["Click on Post a Job"]: false,
                                ["Don't forget to add your files and links"]: false,
                                ["Post to referral timeline"]: true,
                                ["Fill In Details"]: false,
                              };
                              demoAction(dispatch, state);
                              setNewJob((prev) => ({ ...prev, is_draft: "1" }));
                              setTimeout(() => handleSubmit(e, true), 100);
                            }}
                            color="#fff"
                            text={isSavingDraft ? "Saving..." : "Save as Draft"}
                            additionalClass="mt-2"
                            leftALign={false}
                            disabled={isSavingDraft || isEstimatingSalary}
                            style={{ padding: "16px 24px", flex: 1 }}
                          />

                          <CustomButton
                            type="submit"
                            backgroundColor="#41B883"
                            handleClick={(e) => {
                              if (
                                (newJob.job_tier == 2 ||
                                  newJob.job_tier == 3) &&
                                !consentChecked
                              ) {
                                cogoToast.error(
                                  "You must consent to the financial implications before submitting"
                                );
                                return;
                              }
                              e.preventDefault();
                              const userJobCount = job?.myJobs?.length || 0;
                              trackJobPostPublishClick({
                                is_first_time: userJobCount === 0,
                                role_title: newJob.role_title,
                                job_tier: newJob.job_tier,
                              });
                              const state = {
                                ["Post a Job"]: false,
                                ["Click on Post a Job"]: false,
                                ["Don't forget to add your files and links"]: false,
                                ["Post to referral timeline"]: true,
                                ["Fill In Details"]: false,
                              };
                              demoAction(dispatch, state);
                              setNewJob((prev) => ({ ...prev, is_draft: "0" }));
                              setTimeout(() => handleSubmit(e, false), 100);
                            }}
                            color="#fff"
                            text={
                              isEstimatingSalary
                                ? "Fetching Salary Benchmark..."
                                : isPublishingJob
                                ? "Publishing..."
                                : "Publish Job to Referral"
                            }
                            additionalClass="mt-2"
                            leftALign={false}
                            disabled={
                              isPublishingJob ||
                              isEstimatingSalary ||
                              ((newJob.job_tier == 2 || newJob.job_tier == 3) &&
                                !consentChecked)
                            }
                            style={{ padding: "16px 24px", flex: 1 }}
                          />
                        </div>
                      </SlidingPane>

                      <Dialog
                        open={showWarningModal}
                        onClose={cancelClose}
                        aria-labelledby="warning-dialog-title"
                        PaperProps={{
                          style: {
                            borderRadius: "1rem",
                            padding: "1rem",
                            minWidth: "400px",
                          },
                        }}
                      >
                        <DialogTitle id="warning-dialog-title">
                          Unsaved Changes
                        </DialogTitle>
                        <DialogContent>
                          <p>
                            You have unsaved changes. Are you sure you want to
                            leave? All your progress will be lost.
                          </p>
                        </DialogContent>
                        <DialogActions>
                          <CustomButton
                            type="button"
                            backgroundColor="#6c757d"
                            color="#fff"
                            text="Cancel"
                            handleClick={cancelClose}
                            additionalClass="mx-2"
                          />
                          <CustomButton
                            type="button"
                            backgroundColor="#dc3545"
                            color="#fff"
                            text="Leave"
                            handleClick={confirmClose}
                            additionalClass="mx-2"
                          />
                        </DialogActions>
                      </Dialog>
                    </React.Fragment>
                  )}
                </div>
                <SlidingPane
                  className=""
                  overlayClassName="some-custom-overlay-class"
                  isOpen={showConfirmation}
                  title="Job Poster Approval Questionnaire"
                  subtitle="To become an approved job poster, please fill out the job poster questionnaire. Your request will be duly reviewed."
                  width={width <= 1024 ? "100%" : "90%"}
                  height="10%"
                  from={"right"}
                  onRequestClose={() => {
                    // triggered on "<" on left top click or on outside click
                    setShowConfirmation(false);
                    // setOpen(false);
                  }}
                >
                  <div className="col-12 col-md-12 ">
                    <form className="mt-4" onSubmit={handleSubmiting}>
                      <div className="form-group">
                        <label className="text-size" htmlFor="companyName">
                          Hiring company name
                        </label>
                        <CustomInput
                          type="text"
                          className="form-control"
                          id="companyName"
                          value={review.name}
                          onChange={handleForm}
                          name="name"
                          placeholder="Enter Name"
                        />
                      </div>
                      <br />
                      <div className="form-group">
                        <label className="text-size" htmlFor="companyTax">
                          Hiring company Tax ID
                        </label>
                        <CustomInput
                          type="text"
                          className="form-control"
                          value={review.tax_id}
                          onChange={handleForm}
                          id="companyTax"
                          name="tax_id"
                          placeholder="Enter Tax ID"
                        />
                      </div>
                      <br />

                      <div className="form-group">
                        <label className="text-size" htmlFor="companyWebsite">
                          Hiring company website
                        </label>
                        <CustomInput
                          type="text"
                          value={review.website}
                          onChange={handleForm}
                          className="form-control"
                          id="companyWebsite"
                          name="website"
                          placeholder="Enter Website"
                        />
                      </div>
                      <br />

                      <div>
                        <label className="text-size">
                          What is your role in the hiring company?
                        </label>
                        <div className="mt-3 d-flex gap-5">
                          <input
                            type="checkbox"
                            name="role"
                            checked={review.role.includes("Hiring Manager")}
                            onChange={handleForm}
                            value="Hiring Manager"
                          />
                          <br />

                          <label className="mt-2 mx-1 ">Hiring Manager</label>
                        </div>
                        <div className="mt-3 d-flex gap-5">
                          <input
                            type="checkbox"
                            name="role"
                            checked={review.role.includes("Business Owner")}
                            onChange={handleForm}
                            value="Business Owner"
                          />
                          <label className="mt-2 mx-1">Business Owner</label>
                        </div>
                        <div className="mt-3 d-flex gap-5">
                          <input
                            type="checkbox"
                            name="role"
                            checked={review.role.includes("Recruiter")}
                            onChange={handleForm}
                            value="Recruiter"
                          />
                          <label className="mt-2 mx-1">
                            Recruiter/HR Manager
                          </label>
                        </div>
                        <div className="mt-3 d-flex gap-5">
                          <input
                            type="checkbox"
                            name="role"
                            checked={review.role.includes(
                              "Not affiliated with hiring company"
                            )}
                            onChange={handleForm}
                            value="Not affiliated with hiring company"
                          />
                          <label className="mt-2 mx-1">
                            Not affiliated with hiring company
                          </label>
                        </div>
                      </div>
                      <br />
                      {/* <div className="mt-3 d-flex gap-5">
                        <input
                          type="checkbox"
                          name="role"
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                        />
                        <label className="mt-2 mx-1">
                          I agree to pay the placement fees in full, from all
                          successful hires through the workbrook platform.
                        </label>
                      </div> */}

                      <br />

                      <div className="mt-5 col-12 col-md-12">
                        <CustomButton
                          type="submit"
                          backgroundColor="#3A6ED4"
                          color="#fff"
                          text={isSubmitting ? "Submitting..." : "Submit"}
                          disabled={
                            isSubmitting ||
                            !review.name ||
                            !review.tax_id ||
                            !review.website ||
                            !review.role
                          }
                          additionalClass="mx-3 mt-2"
                        />
                      </div>
                      <div className="mt-3 col-12 col-md-12">
                        <CustomButton
                          backgroundColor="#41B883"
                          color="#fff"
                          onClick={() => setShowConfirmation(false)}
                          text={"Exit"}
                          additionalClass="mx-3 mt-2"
                        />
                      </div>
                    </form>
                  </div>
                </SlidingPane>
              </div>
            )}
          </div>
        </div>
      </main>

      {/* Estimated Salary Modal for Tier 3 */}
      <Dialog
        open={showEstimatedSalaryModal}
        onClose={() => setShowEstimatedSalaryModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ backgroundColor: "#3a6ed4" }}>
          <h2 className="text-white" style={{ fontSize: "1.25rem", margin: 0 }}>
            {estimatedSalaryData?.source === "user_input"
              ? "Confirm your salary"
              : "Estimated salary confirmation"}
          </h2>
        </DialogTitle>
        <DialogContent style={{ padding: "24px" }}>
          {isEstimatingSalary ? (
            <div className="d-flex align-items-center justify-content-center py-4">
              <CircularProgress size={32} />
              <span className="ml-3">Calculating estimated salary...</span>
            </div>
          ) : estimatedSalaryData ? (
            <div>
              <div
                className="mb-4 p-3"
                style={{ backgroundColor: "#f5f5f5", borderRadius: "8px" }}
              >
                <h5 className="mb-2">
                  {estimatedSalaryData.source === "user_input"
                    ? "Salary from your input"
                    : "Estimated market salary"}
                </h5>
                <h3 style={{ color: "#3a6ed4", fontWeight: "bold" }}>
                  {estimatedSalaryData.currency}{" "}
                  {estimatedSalaryData.formatted_salary}
                </h3>
                <small className="text-muted">Per annum</small>
              </div>

              <div className="mb-4">
                <h6 className="mb-2">
                  <strong>Important information:</strong>
                </h6>
                {estimatedSalaryData.source === "user_input" ? (
                  <ul style={{ paddingLeft: "20px", marginBottom: "16px" }}>
                    <li className="mb-2">
                      This amount is derived from the{" "}
                      <strong>salary range and pay period</strong> you entered
                      for this role (converted to an annual figure where needed).
                    </li>
                    <li className="mb-2">
                      This is <strong>not</strong> necessarily the final salary
                      you will pay; you can still negotiate with the hired
                      candidate.
                    </li>
                    <li className="mb-2">
                      This salary figure will be used to calculate your platform
                      posting fee.
                    </li>
                  </ul>
                ) : (
                  <ul style={{ paddingLeft: "20px", marginBottom: "16px" }}>
                    <li className="mb-2">
                      This estimated salary is the{" "}
                      <strong>default market price</strong> for the role you are
                      posting, based on industry standards.
                    </li>
                    <li className="mb-2">
                      This is <strong>NOT</strong> the actual salary you will pay
                      the candidate. You can negotiate the final salary directly
                      with the hired candidate.
                    </li>
                    <li className="mb-2">
                      This estimated salary will be used to calculate your
                      platform posting fee.
                    </li>
                  </ul>
                )}
              </div>

              <div
                className="p-3 mb-3"
                style={{
                  backgroundColor: "#fff3cd",
                  borderRadius: "8px",
                  border: "1px solid #ffc107",
                }}
              >
                <h6 className="mb-2">
                  <strong>Payment Breakdown:</strong>
                </h6>
                <p className="mb-1">
                  <strong>Total fee:</strong>{" "}
                  {estimatedSalaryData.source === "user_input"
                    ? "10% of this salary"
                    : "10% of estimated salary"}{" "}
                  = {estimatedSalaryData.currency}{" "}
                  {(estimatedSalaryData.estimated_salary * 0.1).toLocaleString(
                    "en-US"
                  )}
                </p>
                <p className="mb-1">
                  <strong>Upfront payment:</strong>{" "}
                  {estimatedSalaryData.source === "user_input"
                    ? "3% of this salary"
                    : "3% of estimated salary"}{" "}
                  = {estimatedSalaryData.currency}{" "}
                  {(estimatedSalaryData.estimated_salary * 0.03).toLocaleString(
                    "en-US"
                  )}
                </p>
                {(() => {
                  const walletCur = userData?.country === "160" ? "NGN" : "USD";
                  const jobCur = estimatedSalaryData.currency;
                  if (walletCur !== jobCur) {
                    return (
                      <p className="mb-0 mt-2" style={{ fontSize: "0.85rem", color: "#856404" }}>
                        <strong>Note:</strong> Your wallet is in <strong>{walletCur}</strong>.
                        The {jobCur} amount will be converted to {walletCur} at the current
                        exchange rate when charged.
                      </p>
                    );
                  }
                  return null;
                })()}
              </div>

              <p className="text-muted" style={{ fontSize: "0.875rem" }}>
                By clicking "Accept & Continue", you acknowledge that you
                understand these terms and agree to proceed with the job
                posting.
              </p>
            </div>
          ) : null}
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px" }}>
          <CustomButton
            backgroundColor="#e0e0e0"
            color="#333"
            text="Cancel"
            handleClick={() => {
              setShowEstimatedSalaryModal(false);
              setEstimatedSalaryData(null);
            }}
            style={{ padding: "10px 24px", marginRight: "12px" }}
          />
          <CustomButton
            backgroundColor="#3a6ed4"
            color="#fff"
            text={isPublishingJob ? "Publishing..." : "Accept & Continue"}
            handleClick={submitJobWithEstimatedSalary}
            disabled={isPublishingJob || !estimatedSalaryData}
            style={{ padding: "10px 24px" }}
          />
        </DialogActions>
      </Dialog>

      {/* Insufficient Balance - Fund Wallet Modal */}
      <Dialog
        open={showFundWalletModal}
        onClose={() => setShowFundWalletModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ backgroundColor: "#dc3545" }}>
          <h2 className="text-white" style={{ fontSize: "1.25rem", margin: 0 }}>
            Insufficient Wallet Balance
          </h2>
        </DialogTitle>
        <DialogContent style={{ padding: "24px" }}>
          <div
            className="p-3 mb-3"
            style={{
              backgroundColor: "#fff3cd",
              borderRadius: "8px",
              border: "1px solid #ffc107",
            }}
          >
            <p className="mb-2">
              {fundWalletInfo?.message}
            </p>
            <p className="mb-0 text-muted" style={{ fontSize: "0.875rem" }}>
              This is the 3% upfront placement fee based on the estimated salary.
              Please fund your wallet and try again.
            </p>
          </div>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px" }}>
          <CustomButton
            backgroundColor="#e0e0e0"
            color="#333"
            text="Cancel"
            handleClick={() => setShowFundWalletModal(false)}
            style={{ padding: "10px 24px", marginRight: "12px" }}
          />
          <CustomButton
            backgroundColor="#3a6ed4"
            color="#fff"
            text="Fund Wallet"
            handleClick={() => {
              trackEvent("fund_wallet_click", "payment", {
                source: "modal",
              });
              setShowFundWalletModal(false);
              history.push("/wallet/add");
            }}
            style={{ padding: "10px 24px" }}
          />
        </DialogActions>
      </Dialog>

      {/* Job Template Selector Modal */}
      <JobTemplateSelector
        open={showTemplateSelector}
        onClose={() => setShowTemplateSelector(false)}
        onSelectTemplate={handleTemplateSelected}
        onCreateNew={handleCreateNewFromSelector}
      />

      <RequestHiringSupport
        open={requestHiringSupportOpen}
        onClose={() => setRequestHiringSupportOpen(false)}
      />

      {/* Employer Verification Modal (Intent-First Publish Gate) */}
      <EmployerVerificationModal
        open={showVerificationModal}
        onClose={() => setShowVerificationModal(false)}
        onSubmit={handleEmployerVerificationSubmit}
      />

      <Dialog
        open={employerVerificationEmailNotice.open}
        onClose={() =>
          setEmployerVerificationEmailNotice({ open: false, companyEmail: "" })
        }
        aria-labelledby="employer-verification-email-notice-title"
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: { borderRadius: "1rem", padding: "0.25rem" },
        }}
      >
        <DialogTitle
          id="employer-verification-email-notice-title"
          style={{ paddingBottom: 8 }}
        >
          Check your company email
        </DialogTitle>
        <DialogContent>
          <p style={{ margin: "0 0 12px", fontSize: "0.95rem", lineHeight: 1.5 }}>
            We sent a verification link to{" "}
            {employerVerificationEmailNotice.companyEmail ? (
              <strong>{employerVerificationEmailNotice.companyEmail}</strong>
            ) : (
              "your company email address"
            )}
            . Open that inbox and click the link to verify your employer account.
            After you confirm, your job will be published automatically.
          </p>
          <p style={{ margin: 0, fontSize: "0.9rem", color: "#64748b" }}>
            Didn&apos;t receive it? Check your spam or junk folder. The link
            expires after 48 hours; if it expired, submit your verification again
            or contact support.
          </p>
        </DialogContent>
        <DialogActions style={{ padding: "8px 24px 20px" }}>
          <CustomButton
            backgroundColor="#1d4ed8"
            color="#fff"
            text="Go to My Jobs"
            handleClick={() => {
              setEmployerVerificationEmailNotice({ open: false, companyEmail: "" });
              history.push("/myjobs");
            }}
            style={{ padding: "10px 24px" }}
          />
        </DialogActions>
      </Dialog>
      <ChatWidget ref={chatWidgetRef} />
    </div>
  );
};

Layout.propTypes = {
  children: node.isRequired,
  recruiter: bool,
  isOnDuplicatePost: bool,
  duplicatedDataValue: object,
  onDuplicateClose: func,
};

Layout.defaultProps = {
  recruiter: false,
  isOnDuplicatePost: false,
  duplicatedDataValue: null,
  onDuplicateClose: () => {},
};

export default Layout;
